import {
  type HttpInterceptorFn,
  type HttpRequest,
  type HttpHandlerFn,
  type HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import {layoutStore} from '@/app/layout/store/layout.store';
import {StorageKeys} from '@/app/core/enums/storage-keys';
import {environment} from '@/environments/environment';
import type {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
const CLIENT_TYPES = ['client', 'tenantClient', 'Tenant Client'];

export const authApiInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const isApi = req.url.startsWith(environment.baseUrl);

  let request = req;
  if (isApi) {
    const lang = layoutStore.language() || 'ar';
    const headers: Record<string, string> = {
      'Accept-Language': lang,
    };
    const token = getStoredToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    request = req.clone({setHeaders: headers});
  }

  return next(request).pipe(
    map((event) => {
      if (
        isApi &&
        event instanceof HttpResponse &&
        event.body != null &&
        typeof event.body === 'object' &&
        !Array.isArray(event.body) &&
        'data' in event.body
      ) {
        const body = event.body as {data: unknown};
        return event.clone({body: body.data});
      }
      return event;
    }),
  );
};

function getStoredToken(): string | null {
  try {
    const sessionContext = sessionStorage.getItem(
      StorageKeys.ACTIVE_AUTH_CONTEXT,
    );
    const activeContext =
      sessionContext === 'client' || sessionContext === 'tenant'
        ? sessionContext
        : null;

    const contextKey =
      activeContext === 'client'
        ? StorageKeys.USER_DATA_CLIENT
        : activeContext === 'tenant'
          ? StorageKeys.USER_DATA_TENANT
          : null;

    const rawCandidates = [
      contextKey ? sessionStorage.getItem(contextKey) : null,
      contextKey ? localStorage.getItem(contextKey) : null,
      sessionStorage.getItem(StorageKeys.USER_DATA),
      localStorage.getItem(StorageKeys.USER_DATA),
      sessionStorage.getItem(StorageKeys.USER_DATA_CLIENT),
      localStorage.getItem(StorageKeys.USER_DATA_CLIENT),
      sessionStorage.getItem(StorageKeys.USER_DATA_TENANT),
      localStorage.getItem(StorageKeys.USER_DATA_TENANT),
    ];

    for (const raw of rawCandidates) {
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      const token = parsed?.token ?? null;
      if (!token) continue;
      const context = CLIENT_TYPES.includes(parsed?.user?.type ?? '')
        ? 'client'
        : 'tenant';
      if (activeContext && context !== activeContext) continue;
      return token;
    }
  } catch {}
  return null;
}
